import * as React from 'react'

import { JsonView, darkStyles, defaultStyles } from 'react-json-view-lite'
import 'react-json-view-lite/dist/index.css'

export const SettingsSubscriptionJsonView = ({ data }: { data: any }) => {
  return <JsonView data={data} shouldInitiallyExpand={(level) => level < 1} style={defaultStyles} />
}
